// extracted by mini-css-extract-plugin
export default {"desktopOnly":"XWLnWvPbS45lsY4FhsFc","mobileOnly":"nXVE0eEY8jZOjBv_Hib1"};